// reservation/index.tsx

import { useEffect, useState } from "react";
import { useReservation } from "./hooks/useReservation";
import CreateReservationPopup from "./component/createReservationPopup";
import CurrentReservation from "./component/currentReservation";
import {
  ColumnItem,
  HeaderItem,
  PageContentHeader,
  PageContentHeaderActionsWrapper,
  PageContentHeaderButton,
  PageContentWrapper,
  PageHeader,
  PageWrapper,
  TableContent,
  TableContentWrapper,
  TableHeader,
} from "../../styles/page";
import { styled } from "styled-components";
import {
  PaginationWrapper,
  TableActions,
  TableProps,
  TableRowButton,
} from "../../component/CommonTable";
import {
  removeReservations,
  SellerReservationDto,
} from "../../api/reservation";
import EditReservationImagePopup from "./component/editReservationPopup";
import DeletePopup from "./component/deletePopup";
import Pagination from "../../component/Pagination";
import { useRecoilValue } from "recoil";
import { pubState } from "../../recoil/pub.atom";
import { Overlay } from "../../styles/popup";
import { useNavigate } from "react-router-dom";
import { PubOwnerRole, PubOwnerDomain } from "../../api/cafe";

const TableContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const FullHeightReservationWrapper = styled(PageContentWrapper)`
  display: flex;
  flex-direction: column;
`;

const Reservation = () => {
  const {
    list,
    currentPage,
    totalPages,
    handlePageChange,
    getMyReservations,
    CopyReservationLink,
  } = useReservation(10);
  const pub = useRecoilValue(pubState);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isCurrentOpen, setIsCurrentOpen] = useState(false);
  const [isDelOpen, setIsDelOpen] = useState(false);
  const [currentReservation, setCurrentReservation] =
    useState<SellerReservationDto | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number[]>([]);
  const editClose = (isOpen: boolean) => {
    getMyReservations().then((t) => setIsEditOpen(isOpen));
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.RESERVATION)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const columns: TableProps<SellerReservationDto>["columns"] = [
    {
      key: "tournamentStart",
      header: "날짜",
      render: (item) => item.tournamentStart.slice(0, 10),
      weight: 1.5,
      style: "date",
    },
    {
      key: "tournamentStart",
      header: "시작 시간",
      render: (item) => item.tournamentStart.slice(10),
      weight: 1.5,
    },
    {
      key: "title",
      header: "토너먼트 이름",
      weight: 8,
      style: "name",
    },
    {
      key: "actions",
      header: "",
      weight: 3,
      render: (item) => renderActions(item),
    },
  ];
  const handleSelect = (id: number) => {
    setSelectedIndex((prev: number[]) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };
  const renderCheck = (item: SellerReservationDto) => {
    return selectedIndex ? (
      selectedIndex.includes(item.id) ? (
        <div
          className="box"
          style={{
            background: "#7f25fb",
          }}
        >
          <img
            src="/image-web/tournament/reservation-selected.svg"
            alt="Selected"
            onClick={() => handleSelect(item.id)}
          />
        </div>
      ) : (
        <div
          className="box"
          style={{
            background: "#fff",
          }}
        >
          <img
            src="/image-web/tournament/reservation-un-selected.svg"
            alt="Selected"
            onClick={() => handleSelect(item.id)}
          />
        </div>
      )
    ) : (
      <></>
    );
  };

  const isCheck = (item: SellerReservationDto) => {
    if (selectedIndex.includes(item.id)) {
      return true;
    }
    return false;
  };

  const deleteSelectedReservation = async () => {
    if (selectedIndex.length === 0) {
      alert("삭제할 예약 목록을 선택해주세요.");
      return;
    }
    try {
      await removeReservations(selectedIndex);
      getMyReservations();
      setSelectedIndex([]);
    } catch (e: any) {
      alert(e.message);
    }
  };

  const renderActions = (item: SellerReservationDto) => (
    <TableActions>
      <TableRowButton
        $variant="negative"
        onClick={() => {
          setIsCurrentOpen(true);
          setCurrentReservation(item);
        }}
      >
        현황
      </TableRowButton>
      <TableRowButton
        $variant="negative"
        onClick={() => {
          setIsEditOpen(true);
          setCurrentReservation(item);
        }}
      >
        수정
      </TableRowButton>
      <TableRowButton
        $isSelected={selectedIndex.includes(item.id)}
        $variant="positive"
        $weight={2}
        onClick={() => CopyReservationLink(item)}
      >
        예약링크 복사
      </TableRowButton>
    </TableActions>
  );

  return (
    <PageWrapper>
      <PageHeader>예약 관리</PageHeader>
      <FullHeightReservationWrapper>
        <PageContentHeader>
          <div />
          <PageContentHeaderActionsWrapper>
            <PageContentHeaderButton
              $variant={"negative"}
              onClick={() => {
                if (selectedIndex.length > 0) setIsDelOpen(true);
              }}
            >
              삭제({selectedIndex.length})
            </PageContentHeaderButton>
            <PageContentHeaderButton
              $variant={"positive"}
              onClick={() => setIsCreateOpen(true)}
            >
              예약 만들기
            </PageContentHeaderButton>
          </PageContentHeaderActionsWrapper>
        </PageContentHeader>
        <TableContainer>
          <TableHeader>
            {columns.map((column, index) => (
              <HeaderItem
                className={`i${index}`}
                weight={column.weight}
                key={index}
              >
                {column.header}
              </HeaderItem>
            ))}
          </TableHeader>
          <TableContentWrapper>
            {list.map((item, rowIndex) => (
              <div className="data-wrapper">
                <div className="checkbox">{renderCheck(item)}</div>
                <TableContent key={rowIndex} select={isCheck(item)}>
                  {columns.map((column, colIndex) => (
                    <ColumnItem
                      className={`i${colIndex}`}
                      weight={column.weight}
                      key={colIndex}
                    >
                      <span>
                        {column.key === "actions"
                          ? renderActions(item)
                          : column.key === "check"
                            ? null
                            : column.render
                              ? column.render(item)
                              : String(item[column.key])}
                      </span>
                    </ColumnItem>
                  ))}
                </TableContent>
              </div>
            ))}
          </TableContentWrapper>
          {totalPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </PaginationWrapper>
          )}
        </TableContainer>
      </FullHeightReservationWrapper>

      {isEditOpen && (
        <EditReservationImagePopup
          setIsEditOpen={editClose}
          reservationId={currentReservation?.id}
          imageUrl={currentReservation?.imageUrl}
        />
      )}

      {isCreateOpen && (
        <CreateReservationPopup
          setIsCreateOpen={setIsCreateOpen}
          getList={getMyReservations}
        />
      )}
      {(isCreateOpen || isEditOpen || isDelOpen || isCurrentOpen) && (
        <Overlay />
      )}

      {isCurrentOpen && currentReservation && (
        <CurrentReservation
          currentReservation={currentReservation}
          setIsCurrentOpen={setIsCurrentOpen}
        />
      )}

      {isDelOpen && (
        <DeletePopup
          isCheck={isCheck}
          total={selectedIndex.length}
          paginatedList={list}
          onClose={() => setIsDelOpen(false)}
          deleteSelectedReservation={deleteSelectedReservation}
        />
      )}
    </PageWrapper>
  );
};

export default Reservation;
